// Lazy loader for the <ssi-lesson-player> custom element.
//
// Only some routes actually use the player (Home, all 10 /learn/:lang
// slugs, /tutors, /schools1, /schools2). Loading the 44 KB script
// in index.html as a global side-effect meant the other routes
// paid for it too. This loader injects the script tag on first use and
// caches the resulting promise, so subsequent calls (StrictMode double-
// mount, route revisits) are no-ops.

let loadingPromise = null;

export function ensureLessonPlayer() {
  // Already registered? Nothing to do.
  if (typeof window === 'undefined') return Promise.resolve();
  if (window.customElements && window.customElements.get('ssi-lesson-player')) {
    return Promise.resolve();
  }
  // In flight from a previous call? Reuse.
  if (loadingPromise) return loadingPromise;

  loadingPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.type = 'module';
    s.src = '/lesson-player/ssi-lesson-player.js';
    s.async = true;
    s.onload = () => resolve();
    s.onerror = (err) => {
      // Drop the cached promise so a retry on next mount can try again.
      loadingPromise = null;
      reject(err);
    };
    document.head.appendChild(s);
  });

  return loadingPromise;
}
